export default __webpack_public_path__ + "static/media/p04 p04.97846fb4.jpg";